import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { NotifyUsersBy } from '../../constants/KRollConstants';
import { KRollService } from '../../services/api-services/kroll.service';
import { UserService } from '../../services/api-services/user.service';
import { FormService } from '../../services/form.service';
import { HelperService } from '../../services/helper.service';
import { arrayMinLengthByKey } from '../../validator/form-validators.service';
import { ValidationMessagesService } from '../../validator/validation-messages.service';
import { DeliveryStatusComponent } from '../delivery-status/delivery-status.component';
import { AddReasonPopupComponent } from '../add-reason-popup/add-reason-popup.component';
import { ModalService } from 'src/app/core/services/modal.service';
import { AuthService } from '@apiServices';
import { PreAssessmentService } from '../../services/api-services/pre-assessments.service';
@Component({
  selector: 'app-renew-refill-request',
  templateUrl: './renew-refill-request.component.html',
  styleUrls: ['./renew-refill-request.component.scss']
})
export class RenewRefillRequestComponent implements OnInit {
  selectedUserList: any[] = [];
  RenewRefillStatusID: any = "";
  statusReason: any = "";
  isUpdateAll: boolean = false;
  disableButton: boolean;
  type: any;
  user: any;
  status: any[] = [];
  rejectedReason: any[] = [];
  rejectedReasonRequired: boolean = true;
  form: FormGroup = new FormGroup({});
  isLoading: boolean = false;
  tenant: any = localStorage.getItem('tenant')
  payload: { NotifyUsers: boolean, NotifyUsersBy: Array<number> } = {
    NotifyUsers: false,
    NotifyUsersBy: []
  }
  showInternalNotes: boolean = false;
  isReasonLoaded: boolean = false;
  isMessageLoaded: boolean = true;
  isPatientMessage: boolean = true;
  selectedReason: any;
  constructor(
    public dialogRef: MatDialogRef<DeliveryStatusComponent>,
    public dialog: MatDialog,
    public authService: AuthService,
    private fb: FormBuilder,
    public toast: ToastrService,
    public userService: UserService,
    private route: ActivatedRoute,
    public formService: FormService,
    public krollService: KRollService,
    public validationMessagesService: ValidationMessagesService,
    public helperService: HelperService,
    public modalService: ModalService,
    public preAssessmentService: PreAssessmentService,
    @Optional() @Inject(MAT_DIALOG_DATA) public props: any
  ) {
    this.disableButton = false;
    if (!this.props.item.RenewRefillStatusID) {
      this.isUpdateAll = true;
    }
    else {
      this.RenewRefillStatusID = this.props.item.RenewRefillStatusID
    }
    this.initializeForm();

  }

  ngOnInit(): void {
    this.getUserData(); 
    this.getRejectedReason(this.helperService.stringConvertToTitleCase((this.props.item.clicked_on)));
     if (this.isUpdateAll) {
      this.getRefillStatus();
    }
    this.getCustomMessage();
    // this.form.get('RejectedReasonID')?.valueChanges.subscribe((change: any) => {
    //   debugger;
    //   if (change != null || change != undefined) {
    //     this.showInternalNotes = true;
    //     this.isMessageLoaded = false;
    //     this.onReasonChange(this.props.item.clicked_on);
    //   } else {
    //     this.showInternalNotes = false;
    //   }
    // })
  }

  RejectedReasonIDChange(event: any) { 
    if (event != null || event != undefined) {
      this.showInternalNotes = true;
      this.isMessageLoaded = false;
      this.onReasonChange(this.helperService.stringConvertToTitleCase((this.props.item.clicked_on)));
    } else {
      this.showInternalNotes = false;
    }
  }
  onCheckChange(event: MatCheckboxChange) {
    if (event.checked) {
      this.addNotifyControl();
    }
    else {
      this.form.removeControl('NotifyUsersBy');
    }
  }

  initializeForm() {
    let { NotifyUsers } = this.payload;
    this.form = this.fb.group({
      NotifyUsers: new FormControl(NotifyUsers),
      RenewRefillStatusID: new FormControl(""),
      RejectedReasonID: new FormControl("", (this.RenewRefillStatusID == 4 || this.RenewRefillStatusID == 14) ? [Validators.required] : [Validators.nullValidator]),
      custom_message: new FormControl({ value: false, disabled: this.RenewRefillStatusID === 4 || this.RenewRefillStatusID === 14 }),
      RenewRefillStatusType: new FormControl("", this.isUpdateAll ? [Validators.required] : [Validators.nullValidator]),
      message: new FormControl(""),
      internal_notes: new FormControl(''),
    });
  }
  get notifyByArray() {
    return this.form.get('NotifyUsersBy') as FormArray;
  }
  private addNotifyControl() {
    this.form.addControl('NotifyUsersBy', this.fb.array([], arrayMinLengthByKey(1, 'isChecked')));
    NotifyUsersBy.forEach((x: any) => {
      this.notifyByArray.push(this.fb.group({
        id: new FormControl(x.id),
        value: new FormControl(x.value),
        isChecked: new FormControl(x.isChecked),
        disable: new FormControl(this.tenant == 'sl' ? true : false)
      }));
    });
  }


  renewRefillStatusChange() {
    if (this.RenewRefillStatusID == 4 || this.RenewRefillStatusID == 14) {
      const selectedId = this.form.get('RenewRefillStatusType')?.value;
      this.selectedReason = this.status?.find((item: any) => item.id === selectedId)?.type;
      this.getRejectedReason(this.helperService.stringConvertToTitleCase((this.props.item.clicked_on)));
      this.form.get('message')?.setValue('');
      this.form.get('custom_message')?.setValue(false);
      this.form.get('custom_message')?.disable();
    } else {
      this.renewRefillNotRejected();
      this.form.get('message')?.setValue('');
      this.form.get('custom_message')?.setValue(false);
      this.form.get('custom_message')?.disable();
      this.form.get('RejectedReasonID')?.setValue(null);
    }
  }

  renewRefillNotRejected() {
    if (this.RenewRefillStatusID == 4 || this.RenewRefillStatusID == 14) {
      this.form.controls.RejectedReasonID.setValidators([Validators.required]);
    }
    else {
      this.form.controls.RejectedReasonID.clearValidators();
      this.form.controls.RejectedReasonID.updateValueAndValidity({ emitEvent: false });
    }

    let status = this.status.filter(res => res.id == this.form.value.RenewRefillStatusType);
    let payload = {
      "Type": this.props.item[0].Type,
      "Status": status[0].type
    }

    this.userService.get_status_messages(payload).subscribe(res => {
      if (res.body.success) {
        this.form.controls.message.setValue(res.body.data);
        this.form.get('message')?.enable();
        this.form.get('custom_message')?.enable();
      }
      else {
        this.isLoading = false;
        this.toast.error(res.body.message);
      }
    }, err => {
      this.isLoading = false;
    })
  }
  getRefillStatus() {
    // renewal
    const payload : any = { "Type": "refill" }
    this.userService.get_renew_refill_status(payload).subscribe(res => {
      let statusType: any;
      if (res['body']['success']) {
        Object.values(this.props['item']).forEach((element: any) => {
          if (element?.StatusType != undefined) {
            try {
              statusType = element?.StatusType;
            } catch (error) {
              console.log('err', error)
            }
          }
        })
        this.status = res['body']['data'].filter((f: any) => f.statusType == statusType);
      }
      else {
        this.status = [];
      }
    })
  }
  getRejectedReason(clicked_on: any) {
    const reasonMap: { [key: string]: number } = { Refill: 1, Renew: 2 };
    const reason_from = reasonMap[clicked_on];
    const payload = { reason_from };
    this.userService.get_rejected_reason(payload).subscribe(res => {
      if (res.body['success']) {
        this.rejectedReason = res.body['data'];
        this.isReasonLoaded = true;
      }
      else {
        this.rejectedReason = [];
        this.isReasonLoaded = true;
      }
    })
  }
  getUserData() {
    this.authService.user.subscribe(user => {
      this.user = user?.admin;

    });
  }

  async procesMultipleCandidates() {
    let payload: any[] = [];
    let RefillRequestID_ = 0;
    let RenewRequestID_ = 0;
    Object.values(this.props['item']).forEach((element: any) => {
      try {
        if (element.RenewRefillStatusID) {
          if (element.RenewRefillRequestID > 0 && element.IsAnyRefillRequest > 0) {
            RefillRequestID_ = element.RenewRefillRequestID;
          }
          if (element.RenewRefillRequestID > 0 && element.IsAnyRenewRequest > 0) {
            RenewRequestID_ = element.RenewRefillRequestID;
          }
          this.type = element.Type;
          let data = {
            RenewRefillDetailID: element.RenewRefillDetailID,
            RefillRequestID: RefillRequestID_,
            RenewRequestID: RenewRequestID_,
            RenewRefillStatusID: this.RenewRefillStatusID,
            StatusReason: this.statusReason,
            RxNum: element.RxNum,
            OrigRxNum: element.OrigRxNum,
            UserID: element.UserID,
            RenewRefillID: element.RenewRefillID,
            CustomMessage: this.form.get('custom_message')?.value,
            Message: encodeURIComponent(this.form.get('custom_message')?.value ? this.form.get('message')?.value : ''),
            DrgID: element.DrgID,
            NotifyUsers: this.form.value.NotifyUsers ? [element.UserID] : [],
            NotifyUsersBy: this.form.value.NotifyUsersBy?.length > 0 ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id) : [],
            LoggedInUserID: this.user.id,
            reason_id: this.form.value.RejectedReasonID
          };
          // if(this.tenant == 'sl'){
          //   delete data.Message
          // }
          payload.push(data);
        }
      } catch (error) {
      }
    })
    return payload
  }

  formSubmit() {
    this.isLoading = true;
    if ((this.RenewRefillStatusID === 4 || this.RenewRefillStatusID === 14) && (this.form.get('RejectedReasonID')?.value == null || this.form.get('RejectedReasonID')?.value == "")) {
      this.toast.error('Please select reason');
      this.isLoading = false;
      return;
    }
    if (this.form.valid) {
      if (this.RenewRefillStatusID === 4 || this.RenewRefillStatusID === 14) {
        this.statusReason = this.rejectedReason.filter((f: any) => f.id === this.form.value.RejectedReasonID)[0].reason;
      }
      this.disableButton = true;
      this.isLoading = true;
      let RefillRequestID_ = 0;
      let RenewRequestID_ = 0;
      //******for all update *******/
      if (this.isUpdateAll) {
        this.procesMultipleCandidates().then((payload: any) => {
          //******backend team required type and data in payload*******/
          let finalPayload: any = {
            Type: this.type,
            data: payload
          }
          this.userService.bulk_update_status(finalPayload).subscribe(res => {
            if (res.body.success) {
              this.toast.success(res.body.message);
              this.isLoading = false;
              this.dialogRef.close({ payload: payload, response: res.body });
            }
            else {
              this.disableButton = false;
              this.isLoading = false;
              this.toast.error(res.body.message);
            }
          }, err => {
            this.isLoading = false;
          });
        });
      }
      //******for single update *******/
      else {
        if (this.props.item.RenewRefillRequestID > 0 && this.props.item.IsAnyRefillRequest > 0) {
          RefillRequestID_ = this.props.item.RenewRefillRequestID;
        }
        if (this.props.item.RenewRefillRequestID > 0 && this.props.item.IsAnyRenewRequest > 0) {
          RenewRequestID_ = this.props.item.RenewRefillRequestID;
        }
        let safeMessage = this.form.get('custom_message')?.value ? this.form.get('message')?.value : '';

        // Normalize the message to replace problematic characters
        safeMessage = safeMessage.replace(/’/g, "'")  // Replace curly apostrophe with straight apostrophe
          .replace(/–/g, "-") // Replace long dash with regular hyphen
          .replace(/“|”/g, '"'); // Replace curly quotes with straight quotes
        let payload = {
          RenewRefillDetailID: this.props.item.RenewRefillDetailID,
          RenewRefillStatusID: this.props.item.RenewRefillStatusID,
          RefillRequestID: RefillRequestID_,
          RenewRequestID: RenewRequestID_,
          StatusReason: this.statusReason,
          RxNum: this.props.item.RxNum,
          OrigRxNum: this.props.item.OrigRxNum,
          UserID: this.props.item.UserID,
          RenewRefillID: this.props.item.RenewRefillID,
          CustomMessage: this.form.get('custom_message')?.value,
          NotifyUsers: this.form.value.NotifyUsers ? [this.props.item.UserID] : [],
          NotifyUsersBy: this.form.value.NotifyUsersBy?.length > 0 ? this.form.value.NotifyUsersBy.filter((f: any) => f.isChecked).map((m: any) => m.id) : [],
          Message: encodeURIComponent(safeMessage),

          // Message: this.form.value.custom_message ? this.form.value.message : "",
          DrgID: this.props.item.DrgID,
          LoggedInUserID: this.user.id,
          internal_notes: this.form.value.internal_notes,
          reason_id: this.form.value.RejectedReasonID
        };
        // if(this.tenant == 'sl'){
        //   delete payload.Message
        // }      
        this.userService.update_refill_request_status(payload).subscribe(res => {
          if (res.body.success) {
            this.toast.success(res.body.message);
            this.isLoading = false;
            this.dialogRef.close({ payload: payload, response: res.body });
          }
          else {
            this.disableButton = false;
            this.isLoading = false;
            this.toast.error(res.body.message);
          }
        }, err => {
          this.toast.error(err.message);
          this.isLoading = false;
        });
      }
    }
    else {
      this.isLoading = false;
      this.validationMessagesService.validateAllFormFields(this.form);
    }
  }

  getCustomMessage() {
    let payload = {
      "Type": this.getType(),
      "Status": this.props?.item?.RenewRefillStatusType.toLowerCase()
    }
    this.userService.get_status_messages(payload).subscribe(res => {
      if (res.body.success) {
        this.form.controls.message.setValue(res.body.data);
      }
      else {
        this.isLoading = false;
        this.toast.error(res.body.message);
      }
    }, err => {
      this.isLoading = false;
    })
  }

  getType() {
    if (this.props?.item?.IsAnyRefillRequest) {
      return 'refill'
    }

    if (this.props?.item?.IsAnyRenewRequest) {
      return 'renew'
    } else {
      return 'refill'
    }
  }

  openAddRasonDialog() {
    const dialogConfig = new MatDialogConfig();
    let dialogRef;
    if (window.innerWidth < 768) {
      dialogConfig.width = "90%";
    }
    else {
      dialogConfig.width = '600px';
    }
    dialogRef = this.dialog.open(AddReasonPopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      if (res.response.success) {
        this.getRejectedReason(this.props.item.clicked_on);
        this.form.controls.RejectedReasonID.setValue(res.response.data.id);
      }
    })
  }

  onReasonChange(clicked_on: any) {
    const reasonMap: { [key: string]: number } = { Refill: 1, Renew: 2 };
    let statusType: any;
    if (Array.isArray(this.props.item) || Object.keys(this.props.item).some(key => !isNaN(Number(key)))) {
      // Handle multiple users
      // Object.values(this.props['item']).forEach((element: any) => {
      // try {
      statusType = this.selectedReason;
      // } catch (error) {
      //   console.error(error);
      // }
      // });
    } else {
      // Handle single user
      try {
        statusType = this.props.item.RenewRefillStatusType;
      } catch (error) {
        console.error(error);
      }
    }
    const payload: any = {
      reason_id: this.form.get('RejectedReasonID')?.value,
      item_type: reasonMap[clicked_on],
      type: statusType
      // user_id: this.props.item.UserID
    }
    try {
      this.preAssessmentService.getPatientFacingContent(payload).subscribe((res: any) => {
        if (res.body.success) {
          this.form.get('message')?.setValue(res?.body?.data?.patient_facing_text);
          this.form.get('custom_message')?.setValue(res?.body?.data?.patient_facing_text ? true : false);
          this.form.value.custom_message = true;
          this.form.get('message')?.disable();
          this.form.get('custom_message')?.disable();
          this.isMessageLoaded = true;
          this.isPatientMessage = res?.body?.data?.patient_facing_text ? true : false
        } else {
          this.toast.error(res.body.message);
        }
      })
    } catch (err) {
      console.log(err)
      this.toast.error('Something went wrong');
    }
  }

  // onReasonUpdate(clicked_on: any) {
  //   const reasonMap: { [key: string]: number } = { Refill: 1, Renew: 2 };
  //   debugger;
  //   const payload: any = {
  //     reason_id: this.form.get('RejectedReasonID')?.value,
  //     item_type: 1,
  //     type: this.props.item.RenewRefillStatusType,
  //     user_id: this.props.item.UserID
  //   }
  //   try {
  //     this.preAssessmentService.getPatientFacingContent(payload).subscribe((res: any) => {
  //       if (res.body.success) {
  //         this.form.get('message')?.setValue(res?.body?.data?.patient_facing_text);
  //         this.form.get('custom_message')?.setValue(res?.body?.data?.patient_facing_text ? true : false);
  //         this.form.value.custom_message = true;
  //         this.form.get('message')?.disable();
  //         this.form.get('custom_message')?.disable();
  //         this.isMessageLoaded = true;
  //         this.isPatientMessage = res?.body?.data?.patient_facing_text ? true : false
  //       } else {
  //         this.toast.error(res.body.message);
  //       }
  //     })
  //   } catch (err) {
  //     console.log(err)
  //     this.toast.error('Something went wrong');
  //   }
  // }
}
